import React, { useContext } from 'react';
import ErrorCircleOutline from '@kyruus/react-ikons/ErrorCircleOutline';

import { DebugErrorBoundaryContext } from '../../lib/contexts';

import {
  ErrorContainer,
  ErrorIconContainer,
  ErrorMessageContainer
} from './styles';

const DebugErrorFallback = ({ error }: { error: Error }) => {
  return (
    <ErrorContainer data-testid="debug-error-fallback">
      <ErrorIconContainer>
        <ErrorCircleOutline color={'red'} size="24px" />
      </ErrorIconContainer>
      <ErrorMessageContainer>{error.toString()}</ErrorMessageContainer>
    </ErrorContainer>
  );
};

const ErrorFallback = ({ error }: { error: Error }) => {
  const isDebugErrorBoundary = useContext(DebugErrorBoundaryContext);

  // if in debug mode, render visible error
  if (isDebugErrorBoundary) {
    return <DebugErrorFallback error={error} />;
  }

  // otherwise render nothing to make the UI as functional as possible
  return <div data-testid="error-fallback" />;
};

export default ErrorFallback;
